export enum CertificateStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Pending = 'PENDING',
  Draft = 'DRAFT',

  // Active and Inactive is only used by UI.  It is a sub status of Approved
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',

  // UI Only
  All = 'ALL',
}
